
export const CompetitionStatusComponentType = {
  unidentified: 'unidentified',
  registeredTeacherRegistrationStage: 'registeredTeacherRegistrationStage',
  studentRegistrationStage: 'studentRegistrationStage',
  unregisteredTeacherRegistrationStage: 'unregisteredTeacherRegistrationStage',
  unregisteredStudentContestStage: 'unregisteredStudentContestStage',
  unregisteredTeacherContestStage: 'unregisteredTeacherContestStage',
  registeredTeacherContestStage: 'registeredTeacherContestStage',
  registeredStudentContestStage: 'registeredStudentContestStage',
  emergencyTeacherContestStage: 'emergencyTeacherContestStage',
  emergencyStudentContestStage: 'emergencyStudentContestStage',
};

